/**
 * Share Module
 * Handles social share functionality
 */

export function initShare() {
  const copyButtons = document.querySelectorAll(".share-copyurl");

  copyButtons.forEach((button) => {
    button.addEventListener("click", (e) => {
      e.preventDefault();
      const url = button.dataset.url;

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(() => {
          showCopiedFeedback(button);
        });
      } else {
        // Fallback for older browsers
        const textArea = document.createElement("textarea");
        textArea.value = url;
        textArea.style.position = "fixed";
        textArea.style.left = "-9999px";
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);
        showCopiedFeedback(button);
      }
    });
  });
}

function showCopiedFeedback(button) {
  button.classList.add("copied");
  setTimeout(() => {
    button.classList.remove("copied");
  }, 2000);
}
